
define('text!modules/creatives/concept/templates/bin_group_name.html',[],function () { return '<div class="concept_icon"></div>\n<div class="group-c">&nbsp;{{bin_group_name}}</div>';});

